<!-- 报表 ==== 对比 -->
<template>
  <div class>
    <div class="flex-1">
      <span class="text-bold">{{ title }}</span>
      <span>{{ time_title }}</span>
    </div>
    <div class="block-preview">
      <div class="flex-wrap details_content">
        <div class="flex-align-center width-full flex-main-start"
             style="line-height: 28px">
          <div v-if="headerShow[0]"
               style="display:flex">
            <component :is="header.quckTime"
                       @change="time_change"
                       :tabPosition="tabPosition"></component>
            <div class="blank_div_cell"></div>
            <component :is="header.datePicker"
                       :class="compareClass[0]"
                       :time="query.time"
                       @change="changeStart"></component>
          </div>
          <div class="flex-main-start padding-left-40"
               v-if="headerShow[1]">
            <span class="padding-right-s font-deep-gray-xxs">门店：</span>
            <!-- <el-cascader :class="compareClass[1]"
                         popper-class="select_drop_theme"
                         class="select_theme"
                         :props="{ expandTrigger: 'hover' }"
                         :options="storeList"
                         v-model="initStore"
                         @change="changeStore"></el-cascader> -->

            <TotastFour
              :project="allLiliaos"
              initEmp="全部"
              @changeStore="changeStore"
            ></TotastFour>

          </div>
          <!-- 对比 -->
          <div class="right right_switch flex-nowrap"
               v-if="contrastStatus">
            <span class="font-deep-gray-xxs padding-right-s">对比：</span>
            <span class="padding-right-md">
              <el-switch v-model="switchStatus"
                         active-color="#3C76FF"
                         inactive-color="#EDEDED"
                         style="width: 120px"
                         @change="onContrast"></el-switch>
            </span>
            <transition name="slide-fade">
              <div v-if="switchStatus"
                   class="flex-nowrap">
                <el-select v-model="checkId"
                           placeholder="请选择"
                           @change="updateCheck">
                  <el-option v-for="(item, index) in options"
                             :key="index"
                             :label="item.label"
                             :value="item.value"></el-option>
                </el-select>
                <span v-if="checked[0]"
                      class="padding-left-10">
                  <label>
                    <div v-if="!showPick"
                         class="a_pick font-theme"
                         :style="{
                        width:
                          header.datePicker === 'MonthPicker'
                            ? '136px'
                            : '174px'
                      }">与其它时间段对比</div>
                    <component month-id="test7"
                               :is="header.datePicker"
                               :time="query.time_contrast"
                               @change="changeEnd"></component>
                  </label>
                </span>
                <span class="padding-left-10-new"
                      v-if="checked[1]">
                  <div class="el-select">
                    <TotastFour
                      :project="allLiliaos"
                      initEmp="全部"
                      @changeStore="changeStore_other"
                      class="store_class"
                    ></TotastFour>
                  </div>
                </span>
                <span v-if="checked[2]"
                      class="padding-left-10">
                  <div class="el-select">
                    <el-select class="font-theme"
                               placeholder="选择对比顾客"
                               v-model="queryData.comParamName"
                               @change="changeCustomer_other">
                      <el-option v-for="item in customerList"
                                 :key="item.isOld"
                                 :label="item.label"
                                 :value="item.isOld"></el-option>
                    </el-select>
                  </div>
                </span>
                <span class="padding-left-10"
                      v-if="checked[3]">
                  <div class="el-select">
                    <el-select class="font-theme"
                               placeholder="选择对比会员"
                               v-model="queryData.comParamName"
                               @change="changeMember_other">
                      <el-option v-for="item in memberList"
                                 :key="item.value"
                                 :label="item.label"
                                 :value="item.value"></el-option>
                    </el-select>
                  </div>
                </span>
                <span class="padding-left-10"
                      v-if="checked[4]">
                  <div class="el-select">
                    <el-cascader popper-class="select_drop_theme"
                                 class="select_theme font-theme"
                                 :props="{ expandTrigger: 'hover' }"
                                 :options="passFlow"
                                 placeholder="选择对比客流渠道"
                                 @change="changeChannel_other"></el-cascader>
                  </div>
                </span>
                <span class="padding-left-10"
                      v-if="checked[5]">
                  <div class="el-select">
                    <el-select class="font-theme"
                               placeholder="选择对比预约渠道"
                               v-model="queryData.comParamName"
                               @change="changeAppoint_other">
                      <el-option v-for="item in appointChannel"
                                 :key="item.value"
                                 :label="item.label"
                                 :value="item.value"></el-option>
                    </el-select>
                  </div>
                </span>
                <div v-if="checked[6]"
                     class="padding-left-10">
                  <el-cascader placeholder="选择对比项目"
                               popper-class="select_drop_theme"
                               class="select-theme"
                               :props="{ expandTrigger: 'hover' }"
                               v-model="compareProject"
                               :options="projectList"
                               @change="changeProject_other"></el-cascader>
                </div>
                <span class="padding-left-10"
                      v-if="checked[7]">
                  <div class="el-select">
                    <el-select class="font-theme"
                               placeholder="选择对比储值卡类型"
                               v-model="queryData.comParamName"
                               @change="changeCard_other">
                      <el-option v-for="item in cardList"
                                 :key="item.cardType"
                                 :label="item.label"
                                 :value="item.cardType"></el-option>
                    </el-select>
                  </div>
                </span>
                <div class="p-l-10"
                     v-if="checked[9]">
                  <div>
                    <div class="button font-theme">
                      <ActivityTotast :activityList="activityList"
                                      @change="changeActContrant"
                                      :compare='true'
                                      :initAct="initCompareAct"></ActivityTotast>
                    </div>
                  </div>
                </div>
                <div class="p-l-10"
                     v-if="checked[10]">
                  <div>
                    <div class="button font-theme">
                      <CouponsTotast :couponsList="couponsList"
                                     @change="changeCouponsContrant"
                                     :compare='true'
                                     :initCop="initCompareCop"></CouponsTotast>
                    </div>
                  </div>
                </div>
              </div>
            </transition>
          </div>
        </div>
      </div>
      <div class="width-full flex-main-start flex-wrap"
           style="line-height: 28px">
        <div class="padding-bottom-s width-full"></div>
        <div class="flex-main-start"
             v-if="headerShow[2]">
          <span class="padding-right-s font-deep-gray-xxs">顾客：</span>
          <el-select :class="compareClass[2]"
                     v-model="queryData.isOld"
                     @change="changeCustomer">
            <el-option v-for="item in customerList"
                       :key="item.isOld"
                       :label="item.label"
                       :value="item.isOld"></el-option>
          </el-select>
        </div>
        <div class="flex-main-start"
             :class="padd_after"
             v-if="headerShow[3]">
          <span class="padding-right-s font-deep-gray-xxs">会员：</span>
          <el-select :class="compareClass[3]"
                     v-model="queryData.customerType"
                     @change="changeMember">
            <el-option v-for="item in memberList"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value"></el-option>
          </el-select>
        </div>
        <div class="flex-main-start padding-left-40"
             v-if="headerShow[4]">
          <span class="padding-right-s font-deep-gray-xxs">客流渠道：</span>
          <el-cascader :class="compareClass[4]"
                       popper-class="select_drop_theme"
                       class="select-md-w"
                       :props="{ expandTrigger: 'hover' }"
                       v-model="initPass"
                       :options="passFlow"
                       @change="changeChannel"></el-cascader>
        </div>
        <div class="flex-main-start padding-left-40"
             v-if="headerShow[5]">
          <span class="padding-right-s font-deep-gray-xxs">预约渠道：</span>
          <el-select :class="compareClass[5]"
                     v-model="queryData.bookSource"
                     @change="changeAppoint">
            <el-option v-for="item in appointChannel"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value"></el-option>
          </el-select>
        </div>
        <div class="flex-main-start padding-left-40"
             v-if="headerShow[6]">
          <span class="padding-right-s font-deep-gray-xxs">项目：</span>
          <el-cascader :class="compareClass[6]"
                       popper-class="select_drop_theme"
                       class="select_themes"
                       :props="{ expandTrigger: 'hover' }"
                       :options="projectList"
                       v-model="initProject"
                       @change="changeProject"></el-cascader>
        </div>
        <div class="flex-main-start"
             :class="padd_after"
             v-if="headerShow[7]">
          <span class="padding-right-s font-deep-gray-xxs">储值卡：</span>
          <el-select :class="compareClass[7]"
                     v-model="cardType"
                     @change="changeCard">
            <el-option v-for="item in cardList"
                       :key="item.cardType"
                       :label="item.label"
                       :value="item.cardType"></el-option>
          </el-select>
        </div>
        <!-- <div class="flex-main-start padding-left-40" v-if="headerShow[8]">
          <span class="padding-right-s font-deep-gray-xxs">理疗师：</span>
          <div class="button" :class="compareClass[8]">
            <TotastThree
              v-if="page.name == 'perform_contrast' || page.name == 'perform_survey'"
              :project="allLiliao"
              initEmp="全部"
              @change="changePer"
            ></TotastThree>
            <TotastTwo
              v-else
              :project="levelProject"
              :allStore="false"
              @change="changePer"
              :dialog="dialogShow"
              :empInitName="empInitName"
            ></TotastTwo>
          </div>
        </div> -->
        <div class="flex-main-start padding-left-40"
             v-if="headerShow[9]">
          <span class="padding-right-s font-deep-gray-xxs">活动：</span>
          <div class="button"
               :class="compareClass[9]">
            <ActivityTotast :dialog="activityShow"
                            :activityList="activityList"
                            :initAct='initAct'
                            :actInitName='actInitName'
                            :initId='initId'
                            @change="changeAcitivity"></ActivityTotast>
          </div>
        </div>
        <div class="flex-main-start padding-left-40"
             v-if="headerShow[10]">
          <span class="padding-right-s font-deep-gray-xxs">优惠券：</span>
          <div class="button"
               :class="compareClass[10]">
            <CouponsTotast :dialog="couponsShow"
                           :couponsList="couponsList"
                           :initCop='initCop'
                           :couInitName='couInitName'
                           :initId='initId'
                           @change="changeCoupons"></CouponsTotast>
          </div>
        </div>
        <div class="flex-main-start padding-left-40"
             v-if="headerShow[11]">
          <span class="padding-right-s font-deep-gray-xxs">来源渠道：</span>
          <el-select :class="compareClass[11]"
                     v-model="queryData.custSource"
                     @change="changeCome">
            <el-option v-for="item in comeChannel"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value"></el-option>
          </el-select>
        </div>
        <!-- <div class="flex-main-start padding-left-40"
             v-if="headerShow[12]">
          <vipHeaderDialog :propDateRange="[queryData.startTime,queryData.endTime]" :headerMemberInfoQueryParam.sync="headerMemberInfoQueryParam" />
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import * as util from "../../../common/util";
import * as queryUtil from "../../../common/query";
import * as consts from "../../../common/const";
import { header } from "./component";
export default {
  components: {
    ...header
  },
  props: {
    title: [String],
    constantKey: [String],
    constantKeyOne: [String],
    constantKeyTwo: [String],
    identifyKey: [String],
    initId: [Number],
    couInitName: [String],
    actInitName: [String],
    createDate: [String],
    contrastStatus: {
      type: Boolean,
      default: function() {
        return true;
      }
    },
    headerChange: [Boolean],
    header: [Object],
    parentID: [Number],
    sortIndex: [Number],
    page: [Object],
    type: [Number],
    headerType: [Number],
    ascending: [Number],
    headerShow: [Array],
    padd_after: {
      type: String,
      default: function() {
        return "padding-left-40";
      }
    }
  },
  data() {
    return {
      s: 1,
      switchStatus: false,
      initMember: [-1],
      query: {
        time: [],
        time_contrast: [],
        time_contrastEnd: []
      },
      queryData: {
        startTime: "",
        endTime: "",
        storeID: JSON.parse(localStorage.getItem("store"))[0].children[0].value,
        customerType: consts.MemberClass[0].value,
        isOld: consts.CustomerClass[0].isOld,
        bookSource: consts.passFlow[0].value,
        custSource: JSON.parse(localStorage.getItem("sourceFlow"))[0].value,
        paramName: "全部",
        compareParam: "",
        comParamName: "",
        miniPrice: 0,
        maxPrice: 0,
        categoryID: "",
        prodID: 0,
        compareType: 0,
        identifyKey: 0,
        headerType: 0,
        constantKey: "",
        parentID: 0,
        constantType: 0,
        type: 0,
        dateFormat: 1,
        pageNum: 1,
        sortIndex: 1,
        ascending: 0,
        sqlType: 1,
        pageSize: 20,
        identityType: 1,
      },
      store: JSON.parse(localStorage.getItem("store")) || [],
      customerList: consts.CustomerClass,
      memberList: consts.MemberClass,
      passFlow: consts.passFlow,
      appointChannel: consts.sourceAppoint,
      comeChannel: JSON.parse(localStorage.getItem("sourceFlow")) || [],
      projectList: JSON.parse(localStorage.getItem("project")) || [],
      cardList: consts.CardType,
      initStore: ["上海", 0],
      initProject: [0],
      compareProject: [0],
      initPass: [-1],
      cardType: consts.CardType[0].cardType,
      tabPosition: "最近30天",
      time_title: "",
      checkId: 1,
      checked: [
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false
      ],
      showPick: false,
      activityShow: true,
      couponsShow: true,
      activityList: [],
      couponsList: [],
      startTime: "",
      endTime: "",
      initAct: "请选择活动",
      initCop: "请选择优惠券",
      initCompareAct: "选择对比活动",
      initCompareCop: "选择对比优惠券",
      activityName: "",
      couponName: "",
      timeQuick: "",
    };
  },
  computed: {
     allLiliaos() {
      let b = [];
      b.push(JSON.parse(localStorage.getItem("regionaList")));
      return b;
    },
    options() {
      let a = [];
      this.headerShow.forEach((item, i) => {
        if (item && this.header.options[i]) {
          a.push(this.header.options[i]);
        }
      });
      return a;
    },
    tab_time: {
      get() {
        return util.report.getime(this.tabPosition);
      },
      set(val) {
        const self = this;
        self.time_title =
          val[0].length <= 10
            ? `（${val.join(" ~ ")}）`
            : `（${val.join(" 与 ")}）`;
      }
    },
    compareClass() {
      let theme = [];
      theme = this.checked.map(check => {
        return this.contrastStatus && check ? "font-theme" : "";
      });
      return theme;
    },
    storeList() {
      return this.store;
    }
  },
  watch: {
    contrastStatus(val) {
      const self = this;
      if (val && self.checked[0]) {
        let b = self.queryData.compareParam.split("/");
        self.tab_time = [
          `${self.queryData.startTime}~${self.queryData.endTime} 与
                         ${b[0]}~${b[1]} `
        ];
      } else {
        self.tab_time = [self.queryData.startTime, self.queryData.endTime];
        this.queryData.compareType = 0;
        this.queryData.comParamName = "";
        this.queryData.compareParam = "";
        queryUtil.setQuery(this.queryData);
      }
    },
    // 切换卡片，表头的某一项不显示，则归为原始值
    headerShow(v) {
      // console.log(this.headerChange,v);
      this.changeContrast();
      if (this.headerChange) {
        v.forEach((item, i) => {
          if (!item) {
            switch (i) {
              case 2:
                this.queryData.isOld = consts.CustomerClass[0].isOld;
                // this.queryData.isOldName=consts.CustomerClass[0].label
                break;
              case 3:
                this.queryData.customerType = consts.MemberClass[0].value;
                // this.queryData.custTypeName=consts.MemberClass[0].label
                break;
              case 4:
                this.initPass = [-1];
                this.queryData.bookSource = consts.passFlow[0].value;
                // this.queryData.bookSourceName=consts.passFlow[0].label
                break;
              case 5:
                // 4和5会冲突，所以当4显示时，5不做任何处理
                if (!v[4]) {
                  this.queryData.bookSource = consts.passFlow[0].value;
                }
                break;
              case 6:
                this.queryData.prodID = 0;
                this.queryData.categoryID = "";
                this.initProject = [0];
                break;
              case 7:
                this.queryData.maxPrice = 0;
                this.queryData.miniPrice = 0;
                this.cardType = -1;
                break;
              default:
                break;
            }
          }
        });
        queryUtil.setQuery(this.queryData);
      }
    },
    constantKey(v) {
      this.queryData.constantKey = v;
      queryUtil.setQuery(this.queryData);
    },
    constantKeyOne(v) {
      this.queryData.constantKey1 = v;
      queryUtil.setQuery(this.queryData);
    },
    constantKeyTwo(v) {
      this.queryData.constantKey2 = v;
      queryUtil.setQuery(this.queryData);
    },
    identifyKey(v) {
      this.queryData.identifyKey = v;
      queryUtil.setQuery(this.queryData);
    },
    type(v) {
      this.queryData.type = v;
      queryUtil.setQuery(this.queryData);
    },
    sortIndex(v) {
      this.queryData.sortIndex = v;
      queryUtil.setQuery(this.queryData);
    },
    headerType(v) {
      this.queryData.headerType = v;
      queryUtil.setQuery(this.queryData);
    },
    "page.sqlType": {
      deep: true, // 深度监听设置为 true
      handler: function(newV) {
        this.queryData.sqlType = newV;
        queryUtil.setQuery(this.queryData);
      }
    },
    parentID(v) {
      this.queryData.parentID = v;
      queryUtil.setQuery(this.queryData);
    },
    ascending(v) {
      // console.log(v);
      this.queryData.ascending = v;
      queryUtil.setQuery(this.queryData);
    },
  },
  created() {
    var {
      headerType,
      constantKey,
      parentID,
      type,
      dateFormat,
      sqlType,
      sortIndex,
      identityType,
      discountType
    } = this.page;
    this.queryData = Object.assign(
      {},
      this.queryData,
      {
        headerType,
        constantKey,
        parentID,
        type,
        dateFormat,
        sqlType,
        sortIndex,
        identityType,
        discountType
      },
      { identifyKey: this.page.tableKey }
    );
    if (
      this.$route.name !== "coupons_index" &&
      this.$route.name.includes("coupons_")
    ) {
      // console.log(this.$route.name, this.initId);
      // 特殊情况。优惠券详情页面，由概况的列表点击跳转进来，有初始默认值，否则弹框提示
      if (this.initId === 0 || this.initId === undefined) {
        this.couponsShow = true;
      } else {
        this.couponsShow = false;
        this.queryData.discountID = this.initId;
        this.queryData.paramName = this.couInitName;
        this.initCop = this.couInitName;
        this.startTime = this.createDate;
        this.endTime = util.nowTime();
        // if (this.initCop.length > 10) {
        //   this.initCop = this.initCop.slice(0, 10) + "...";
        // }
        queryUtil.setQuery(this.queryData);
      }
    } else if (
      this.$route.name !== "activity_index" &&
      this.$route.name.includes("activity_")
    ) {
      // 特殊情况。活动详情页面，由概况的列表点击跳转进来，有初始默认值，否则弹框提示
      if (this.initId === 0 || this.initId === undefined) {
        this.activityShow = true;
      } else {
        this.activityShow = false;
        this.queryData.discountID = this.initId;
        this.queryData.paramName = this.actInitName;
        this.initAct = this.actInitName;
        this.startTime = this.createDate;
        this.endTime = util.nowTime();
        // if (this.initAct.length > 15) {
        //   this.initAct = this.initAct.slice(0, 15) + "...";
        // }
        queryUtil.setQuery(this.queryData);
      }
    }
    if (
      this.header.quckTime === "MonthTab" ||
      this.header.quckTime === "MonthTabEight" ||
      this.header.quckTime === "MonthTabNine"
    ) {
      this.tabPosition = "最近3个月";
      // this.$nextTick(() => {
      this.tab_time = this.query.time = util.report.getMonth(this.tabPosition);
      // console.log(this.tab_time );
      let time = util.report.queryMoreMonth(this.tab_time);
      this.time_change([time.startTime, time.endTime]);
      // });
    } else if (this.header.quckTime === "MonthTabSix") {
      this.tabPosition = "最近6个月";
      this.tab_time = this.query.time = util.report.getMonth(this.tabPosition);
      let time = util.report.queryMoreMonth(this.tab_time);
      this.time_change([time.startTime, time.endTime]);
    } else {
      if (this.header.quckTime === "TimeTab") this.tabPosition = "上周";
      else if (
        this.header.quckTime === "MonthTabTwo" ||
        this.header.quckTime === "MonthTabThree"
      ) {
        this.tabPosition = "最近7天";
      }
      this.tab_time = this.query.time = util.report.getime(this.tabPosition);
      let time = util.report.getime(this.tabPosition);
      this.queryData = Object.assign(
        {},
        this.queryData,
        util.report.queryTime(time)
      );
      queryUtil.setQuery(this.queryData);
    }
    if (this.header.time === "Month") {
      let val = this.moment().format("YYYY-MM");
      this.time_title = "（" + val + ")";
      this.queryData = Object.assign(
        {},
        this.queryData,
        util.report.queryMonth(val)
      );
      queryUtil.setQuery(this.queryData);
    }
    // 市场报表，会员分析，积分分析模块，顾客类型没有散客
    if (
      this.header.name.includes("cust_") ||
      this.header.name.includes("integral_")
    ) {
      // 优惠券分析增加潜客
      this.customerList = consts.CustomerClassTwo;
    } else if (this.header.name.includes("coupons_")) {
      this.customerList = consts.CustomerClassThree;
    }
  },
  mounted() {
    // console.log(this.$attrs);
  },
  methods: {
    updateQuery() {
      queryUtil.setQuery(this.queryData);
      queryUtil.setQueryTable(consts.clearTableQuery);
    },
    clearQuery(v) {
      this.query = Object.assign({}, this.query, { time_contrast: v });
    },
    // 快捷切换3,6,9月
    time_change(val, data) {
      if (val === undefined) return false;
      this.timeQuick = val[0];
      if (this.timeQuick === "活动至今") {
        val = [this.startTime, this.endTime];
      }
      this.tab_time = this.query.time = val;
      this.$emit("select_header", this.query);
      this.changeStart(val);
    },
    // 改变时间
    changeStart(val) {
      const self = this;
      let start = [];
      if (this.header.datePicker === "DatePicker") {
        // 时间选择器为年月日
        start = val.map(item => self.moment(item).format("YYYY-MM-DD"));
      } else if (this.header.datePicker === "MonthPicker") {
        // 时间选择器为年月
        if (val[0].split("-").length <= 2) {
          start.push(
            self
              .moment(val[0])
              .startOf("month")
              .format("YYYY-MM-DD")
          );
          if (self.moment().format("YYYY-MM") === val[1]) {
            start.push(
              self
                .moment()
                .subtract(1, "days")
                .format("YYYY-MM-DD")
            );
          } else {
            start.push(
              self
                .moment(val[1])
                .endOf("month")
                .format("YYYY-MM-DD")
            );
          }
        } else {
          start = val;
        }
      }
      self.query.time = start;
      self.tabPosition = util.report.timeTab(start);
      self.query.time_contrast = util.report.sameTime(start);
      // 数据层
      let time = util.report.queryCompareTime(self.query.time_contrast);
      if (self.queryData.compareType === 1) {
        self.queryData = Object.assign(
          {},
          self.queryData,
          util.report.queryTime(start),
          time
        );
        self.tab_time = [
          self.query.time.join("~"),
          self.query.time_contrast.join("~")
        ];
        self.queryData.compareParam = self.query.time_contrast.join("/");
      } else {
        self.queryData = Object.assign(
          {},
          self.queryData,
          util.report.queryTime(start)
        );
        self.tab_time = start;
      }
      self.$emit("select_header", self.query);
      self.updateQuery();
    },
    // 改变门店
      changeStore(val) {
      this.queryData.storeIDs = val.empIDs;
      queryUtil.setQuery(this.queryData);
    },
    // changeStore(val) {
    //   this.store[0].children.forEach(item => {
    //     if (item.value === val[1]) {
    //       if (this.queryData.compareType && this.queryData.compareType === 2) {
    //         this.queryData.paramName = item.label;
    //       }
    //       this.queryData.storeID = val[1];
    //     }
    //   });
    //   queryUtil.setQuery(this.queryData);
    // },
    // 改变顾客类型
    changeCustomer(val) {
      this.customerList.forEach(item => {
        if (item.isOld === val) {
          if (this.queryData.compareType === 6) {
            this.queryData.paramName = item.label;
          }
          this.queryData.isOld = val;
        }
      });
      queryUtil.setQuery(this.queryData);
    },
    // 改变会员类型
    changeMember(val) {
      this.memberList.forEach(item => {
        if (item.value === val) {
          if (this.queryData.compareType === 3) {
            this.queryData.paramName = item.label;
          }
          this.queryData.customerType = val;
        }
      });
      queryUtil.setQuery(this.queryData);
    },
    // 改变客流渠道
    changeChannel(val) {
      this.passFlow.forEach(item => {
        if (val.length > 1 && item.hasOwnProperty("children")) {
          item.children.forEach(ele => {
            if (ele.value === val[1]) {
              this.queryData.bookSource = val[1];
              if (
                this.queryData.compareType &&
                this.queryData.compareType === 7
              ) {
                this.queryData.paramName = ele.label;
              }
            }
          });
        } else {
          if (item.value === val[0]) {
            this.queryData.bookSource = val[0];
            if (
              this.queryData.compareType &&
              this.queryData.compareType === 7
            ) {
              this.queryData.paramName = item.label;
            }
          }
        }
      });
      queryUtil.setQuery(this.queryData);
    },
    // 改变预约渠道
    changeAppoint(val) {
      this.appointChannel.forEach(item => {
        if (item.value === val) {
          if (this.queryData.compareType === 7) {
            this.queryData.paramName = item.label;
          }
          this.queryData.bookSource = val;
        }
      });
      queryUtil.setQuery(this.queryData);
    },
    // 改变项目
    changeProject(val) {
      let e;
      this.projectList.forEach(item => {
        if (val.length > 1 && item.hasOwnProperty("children")) {
          if (item.value === val[0]) e = item.label;
          item.children.forEach(ele => {
            if (ele.value === val[1]) {
              this.queryData.categoryID = val[0];
              this.queryData.prodID = val[1];
              if (this.queryData.compareType === 4) {
                this.queryData.paramName = e + "/" + ele.label;
              }
            }
          });
        } else {
          this.queryData.categoryID = "";
          this.queryData.prodID = 0;
          if (this.queryData.compareType === 4) {
            this.queryData.paramName = "全部";
          }
        }
      });
      queryUtil.setQuery(this.queryData);
    },
    // 改变储值卡类型
    changeCard(val) {
      this.cardList.forEach(item => {
        if (item.cardType === val) {
          switch (item.label) {
            case "全部":
              this.queryData.miniPrice = 0;
              this.queryData.maxPrice = 0;
              // this.queryData.paramName=item.label
              break;
            case "10000及以上":
              this.queryData.miniPrice = 10000;
              this.queryData.maxPrice = 0;
              // this.queryData.paramName=item.label
              break;
            default:
              let a = item.label.split("-");
              this.queryData.miniPrice = parseInt(a[0]);
              this.queryData.maxPrice = parseInt(a[1]);
              // this.queryData.paramName=item.label
              break;
          }
          if (this.queryData.compareType && this.queryData.compareType === 8) {
            this.queryData.paramName = item.label;
          }
        }
      });
      this.updateQuery();
    },
    // 改变活动
    changeAcitivity(val) {
      this.queryData.discountID = val[0].chooseID;
      this.queryData.paramName = val[0].chooseName;
      this.initAct = val[0].chooseName;
      val[0].startTime === null
        ? (this.startTime = "2015-01-01")
        : (this.startTime = val[0].startTime);
      this.endTime = util.nowTime();
      this.activityName = val[0].chooseName;
      // if (this.initAct.length > 15) {
      //   this.initAct = this.initAct.slice(0, 15) + "...";
      // }
      if (this.timeQuick === "活动至今") {
        this.time_change(["活动至今"]);
      } else {
        this.time_change();
      }
      queryUtil.setQuery(this.queryData);
    },
    // 改变优惠券名称
    changeCoupons(val) {
      this.queryData.discountID = val[0].chooseID;
      this.queryData.paramName = val[0].chooseName;
      this.initCop = val[0].chooseName;
      val[0].startTime === null
        ? (this.startTime = "2015-01-01")
        : (this.startTime = val[0].startTime);
      this.endTime = util.nowTime();
      this.couponName = val[0].chooseName;
      // if (this.initCop.length > 10) {
      //   this.initCop = this.initCop.slice(0, 10) + "...";
      // }
      if (this.timeQuick === "活动至今") {
        this.time_change(["活动至今"]);
      } else {
        this.time_change();
      }
      queryUtil.setQuery(this.queryData);
    },
    // 改变来源渠道
    changeCome(val) {
      this.queryData.custSource = val;
      queryUtil.setQuery(this.queryData);
    },
    // 开启对比 默认对比
    onContrast(val) {
      // 项目分析的项目价格，当PieIndex为数字时会调用下钻饼图的接口，所以清空，只调用一级饼图
      // console.log(val, 44);
      const self = this;
      self.checkId = val ? 1 : 0;
      self.showPick = !val;
      self.checked = self.checked.map(() => false);
      val ? self.checked.splice(0, 1, true) : self.checked.splice(0, 1, false);
      // 对比时间默认
      self.compareStore = self.compareCustomer = self.compareChannel = [];
      if (val) {
        self.queryData = Object.assign({}, self.queryData, consts.clearCompare);
        self.clearQuery(util.report.sameTime(self.query.time));
        // console.log(this.queryData.paramName);
      } else {
        // 不对比
        if (self.queryData.compareType !== 0) {
          self.queryData = Object.assign(
            {},
            self.queryData,
            consts.clearCompare,
            {
              compareType: 0,
              comParamName: "",
              compareParam: "",
              compareStoreIDs: []
            }
          );
          self.tab_time = self.query.time;
          // 活动与优惠券的文字恢复默认
          this.initCompareAct = "选择对比活动";
          this.initCompareCop = "选择对比优惠券";
          self.updateQuery();
          // 反选
          self.clearQuery([]);
        }
        self.$emit("select_header", self.query);
      }
    },
    // 切换对比项目
    updateCheck(index) {
      this.$store.commit({
        type: "getPieIndex",
        index: ""
      });
      this.checkId = index;
      this.checked = this.checked.map(() => false);
      this.checked.splice(index - 1, 1, true);
      this.showPick = false;
      this.queryData = Object.assign({}, this.queryData, consts.clearCompare, {
        compareType: 0,
        comParamName: "",
        compareParam: ""
      });
      this.initCompareAct = "选择对比活动";
      this.initCompareCop = "选择对比优惠券";
    },
    // 切换小卡片，条件变化，对比状态关闭
    changeContrast(i) {
      if (this.headerChange) {
        this.switchStatus = false;
        this.queryData = Object.assign(
          {},
          this.queryData,
          consts.clearCompare,
          { compareType: 0, comParamName: "", paramName: "", compareParam: "" }
        );
        this.compareClass.forEach((item, i) => {
          this.compareClass[i] = "";
        });
        queryUtil.setQuery(this.queryData);
      }
    },
    // 对比时间
    changeEnd(val) {
      this.showPick = true;
      this.query.time_contrast = util.report.sameStart(this.query.time, val);
      console.log("11111111",this.query.time, val,this.query.time_contrast)
      this.tab_time = [
        this.query.time.join("~"),
        this.query.time_contrast.join("~")
      ];
      this.$emit("select_header", this.query);
      // 数据
      this.queryData = Object.assign({}, this.queryData, {
        compareType: 1,
        compareParam:
          this.query.time_contrast[0] + "/" + this.query.time_contrast[1],
        paramName: ""
      });
      this.updateQuery();
    },
    // 对比门店
    changeStore_other(val) {
      this.queryData.comParamName = val.empNames.length > 1 ? '全部' : val.empNames.join(',')
      this.queryData.compareStoreIDs = val.empIDs;
      this.queryData.compareType = 2
      this.updateQuery();
    },
    // 对比会员
    changeMember_other(val) {
      this.memberList.forEach(item => {
        if (item.value === val) {
          this.queryData = Object.assign({}, this.queryData, {
            comParamName: item.label,
            compareParam: val.toString(),
            compareType: 3
          });
        }
        // 对比的时候，让paramName等于正常下拉框此时的label
        if (item.value === this.queryData.customerType) {
          this.queryData.paramName = item.label;
        }
      });
      this.updateQuery();
    },
    // 对比顾客
    changeCustomer_other(val) {
      this.customerList.forEach(item => {
        if (item.isOld === val) {
          this.queryData = Object.assign({}, this.queryData, {
            comParamName: item.label,
            compareParam: val.toString(),
            compareType: 6
          });
        }
        // 对比的时候，让paramName等于正常下拉框此时的label
        if (item.isOld === this.queryData.isOld) {
          this.queryData.paramName = item.label;
        }
      });
      this.updateQuery();
    },
    // 对比客流渠道
    changeChannel_other(val) {
      this.passFlow.forEach(item => {
        if (val.length > 1 && item.hasOwnProperty("children")) {
          item.children.forEach(ele => {
            if (ele.value === val[1]) {
              this.queryData = Object.assign({}, this.queryData, {
                comParamName: ele.label,
                compareParam: val[1].toString(),
                compareType: 7
              });
            }
            if (ele.value === this.queryData.bookSource) {
              this.queryData.paramName = ele.label;
            }
          });
        } else {
          if (item.value === val[0]) {
            this.queryData = Object.assign({}, this.queryData, {
              comParamName: item.label,
              compareParam: val[0].toString(),
              compareType: 7
            });
          }
          if (item.value === this.queryData.bookSource) {
            this.queryData.paramName = item.label;
          }
        }
      });
      this.updateQuery();
    },
    // 对比预约渠道
    changeAppoint_other(val) {
      this.appointChannel.forEach(item => {
        if (item.value === val) {
          this.queryData = Object.assign({}, this.queryData, {
            comParamName: item.label,
            compareParam: val.toString(),
            compareType: 7
          });
        }
        if (item.value === this.queryData.bookSource) {
          this.queryData.paramName = item.label;
        }
      });
      this.updateQuery();
    },
    // 对比项目
    changeProject_other(val) {
      let e;
      if (this.queryData.categoryID === "") this.queryData.paramName = "全部";
      this.projectList.forEach(item => {
        if (val.length > 1 && item.hasOwnProperty("children")) {
          if (item.value === val[0]) e = item.label;
          item.children.forEach(ele => {
            if (ele.value === val[1]) {
              this.queryData = Object.assign({}, this.queryData, {
                comParamName: e + "/" + ele.label,
                compareParam: val[0] + "/" + val[1].toString(),
                compareType: 4
              });
            }
            if (
              ele.value === this.queryData.prodID &&
              item.value == this.queryData.categoryID
            ) {
              this.queryData.paramName = item.label + "/" + ele.label;
            }
          });
        } else {
          this.queryData = Object.assign({}, this.queryData, {
            comParamName: "全部",
            compareParam: "/0",
            compareType: 4
          });
        }
      });
      this.updateQuery();
    },
    // 对比储值卡
    changeCard_other(val) {
      this.cardList.forEach(item => {
        if (item.cardType === val) {
          switch (item.label) {
            case "全部":
              this.queryData.compareParam = "0/0";
              this.queryData.comParamName = item.label;
              break;
            case "10000及以上":
              this.queryData.compareParam = "10000/0";
              this.queryData.comParamName = item.label;
              break;
            default:
              this.queryData.compareParam =
                item.label.split("-")[0] + "/" + item.label.split("-")[1];
              this.queryData.comParamName = item.label;
              break;
          }
        }
        if (item.cardType === this.cardType) {
          this.queryData.paramName = item.label;
        }
      });
      this.queryData.compareType = 8;
      this.updateQuery();
    },
    // 对比活动changeActContrant
    changeActContrant(val) {
      this.queryData.comParamName = val[0].chooseName;
      this.queryData.compareParam = val[0].chooseID.toString();
      this.queryData.compareType = 9;
      this.queryData.paramName =
        this.activityName === "" ? this.actInitName : this.activityName;
      this.initCompareAct = val[0].chooseName;
      if (this.initCompareAct.length > 18) {
        this.initCompareAct = this.initCompareAct.slice(0, 18) + "...";
      }
      this.updateQuery();
    },
    // 对比优惠券
    changeCouponsContrant(val) {
      this.queryData.comParamName = val[0].chooseName;
      this.queryData.compareParam = val[0].chooseID.toString();
      this.queryData.compareType = 9;
      this.queryData.paramName =
        this.couponName === "" ? this.couInitName : this.couponName;
      this.initCompareCop = val[0].chooseName;
      if (this.initCompareCop.length > 18) {
        this.initCompareCop = this.initCompareCop.slice(0, 18) + "...";
      }
      this.updateQuery();
    }
  }
};
</script>

<style lang="less" scoped>
.loadingStyle {
  color: #999999;
}
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.3s ease;
}
.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateX(20px);
  opacity: 0;
}
.button {
  display: inline-block;
  .button-index {
    height: 28px;
    line-height: 28px;
    width: auto;
    min-width: 100px;
    cursor: pointer;
    padding: 0 12px;
  }
}
</style>
